var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-refraction",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "search-refraction-2",
    "data-name": "search-refraction",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M0,5.333a5.333,5.333,0,1,1,5.333,5.333A5.333,5.333,0,0,1,0,5.333Z",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M12,12,9.1,9.1M5.333,2A3.333,3.333,0,0,1,8.667,5.333",
    transform: "translate(2 2)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSearchIcon);
export default __webpack_public_path__ + "static/media/GlobalSearchIcon.98017c0bb96a98476aecd6beba390711.svg";
export { ForwardRef as ReactComponent };